import { MonthPicker } from '@rd-web-markets/shared/dist/util/date';
import ImmutableUnderReviewFormCheck from '@rd-web-markets/shared/dist/util/reviewEditControls/ImmutableUnderReviewFormCheck';
import ImmutableUnderReviewFormControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ImmutableUnderReviewFormControl';
import React from 'react';
import { Col, Form, InputGroup, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
export default function RndProjectDates(_ref) {
  let {
    report,
    isUnderReview,
    pageAccess,
    isOngoing,
    handleDateChange,
    handleSubmit,
    toggleOngoing
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('rnd_project_dates')), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(InputGroup, {
    style: {
      flexWrap: 'nowrap'
    }
  }, /*#__PURE__*/React.createElement(Col, {
    md: 4,
    className: "p-0"
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    disabled: !pageAccess.canEditProjectDetails || isUnderReview,
    as: MonthPicker,
    selected: report.rnd_start_date,
    onChange: date => handleDateChange({
      target: {
        name: 'rnd_start_date',
        value: date
      }
    })
  })), !isOngoing && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, {
    md: 1,
    className: "p-0 ms-2 me-2"
  }, /*#__PURE__*/React.createElement(InputGroup.Text, null, t('to'))), /*#__PURE__*/React.createElement(Col, {
    md: 4,
    className: "p-0"
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    disabled: !pageAccess.canEditProjectDetails || isUnderReview,
    onBlur: handleSubmit,
    as: MonthPicker,
    selected: report.rnd_end_date,
    onChange: date => handleDateChange({
      target: {
        name: 'rnd_end_date',
        value: date
      }
    })
  }))), /*#__PURE__*/React.createElement(Col, {
    md: 3,
    className: "p-1"
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormCheck, {
    disabled: !pageAccess.canEditProjectDetails || isUnderReview,
    checked: isOngoing,
    onBlur: handleSubmit,
    label: t('ongoing'),
    onChange: e => toggleOngoing(e)
  }))))));
}